import Seo from "@/components/Seo";
import SectionHeader from "@/components/SectionHeader";
import CTASection from "@/components/CTASection";
import Reveal from "@/components/Reveal";
import { LinkButton, ExternalButton } from "@/components/Button";
import CrmDashboard from "@/components/mockups/CrmDashboard";
import EngageDashboard from "@/components/mockups/EngageDashboard";
import { PRODUCTS } from "@/lib/content";

const Products = () => (
  <>
    <Seo
      title="Our Products | Kryvo Technologies"
      description="Kryvo CRM and Kryvo Engage — powerful, easy-to-use SaaS products designed to help businesses manage customers, marketing and growth."
    />
    <section className="grid-bg bg-kryvo-mist pb-16 pt-[calc(72px+4rem)] sm:pb-20" data-testid="products-hero">
      <div className="container-x">
        <SectionHeader
          eyebrow="Our Products"
          title="SaaS Products for Modern Businesses"
          description="Powerful, easy-to-use products designed to help businesses manage customers, marketing and growth."
        />
      </div>
    </section>

    <section className="container-x flex flex-col gap-20 py-16 sm:py-24" data-testid="products-list">
      {PRODUCTS.map((p, i) => (
        <Reveal key={p.slug}>
          <div className="grid items-center gap-10 lg:grid-cols-2">
            <div className={i % 2 === 1 ? "lg:order-2" : ""}>
              <span className="inline-block rounded-full bg-kryvo-lime/25 px-3.5 py-1.5 text-xs font-semibold text-kryvo-deep">
                {p.badge}
              </span>
              <h2 className="mt-4 font-display text-3xl font-semibold text-kryvo-ink sm:text-4xl">{p.name}</h2>
              <p className="mt-3 text-lg font-medium text-kryvo-green">{p.headline}</p>
              <p className="mt-4 max-w-lg text-base leading-relaxed text-kryvo-ink/65">{p.description}</p>
              <div className="mt-8 flex flex-wrap gap-3">
                {p.externalUrl ? (
                  <ExternalButton href={p.externalUrl} variant="primary" testId={`products-explore-${p.slug}`}>
                    Explore {p.name}
                  </ExternalButton>
                ) : (
                  <LinkButton to={`/products/${p.slug}`} variant="primary" testId={`products-explore-${p.slug}`}>
                    Explore {p.name}
                  </LinkButton>
                )}
                <LinkButton to="/contact" variant="outline" arrow={false} testId={`products-talk-${p.slug}`}>
                  Talk to Us
                </LinkButton>
              </div>
            </div>
            <div className={i % 2 === 1 ? "lg:order-1" : ""}>
              <div className="relative">
                <div className="absolute -inset-3 sm:-inset-6 rounded-[2rem] bg-gradient-to-br from-kryvo-lime/20 via-kryvo-mist to-kryvo-green/10" aria-hidden="true" />
                <div className="relative aspect-[4/3]">
                  {p.mockup === "crm" ? <CrmDashboard /> : <EngageDashboard />}
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      ))}
    </section>

    <CTASection />
  </>
);

export default Products;
